import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../CommonComponents/PiePage.component'
// import Routes from '../../../../Layout/Routes'
import { CommunityLeadGetUserLoanApi, CommunityLeadSaveUserLoanApi, getStoryLines, loanAmounConfigApiNew, saveStoryLines } from './AddLeadActionCreator'
import InputField from '../../CommonComponents/InputMUI'
import { CommunityLeadLoanValidation } from '../../Validations'
import { WEBSITE } from '../../CommonUtils'
// import DatePicker from '../../../common/DatePickerMUI'
import moment from 'moment'

// const loanTypeArr = [
//     { name: 'Secured Loan', code: 'secured' },
//     { name: 'UnSecured Loan', code: 'unsecured' },
// ]

const AddUi = ({data,handleTab , handlePage}) => {
    const [objectData, setObjectData] = useState({ loanAmount: '', tenurePeriod: "", communityId: window.sessionStorage.getItem("communityId"), loanReason: '', loanType: '', loanProposal: '', expUpperRangeOfInterest: '', expLowerRangeOfInterest: '' })
    const [message, setMessage] = useState({})
    const [storyLineData, setStoryLineData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [messageConfig, setMessageConfig] = useState({})
    const navigate = useNavigate();
    const location = useLocation();

    const forceUpdate = React.useState()[1].bind(null, {})
    const [wordCount, setWordCount] = useState(0);
    let wordLimit = 500;

    useEffect(() => {
        // console.log(location.state)

        if (data !== null && data.rowData !== undefined) {
            getStoryLine(data.rowData.loanId)

            let changeObjectData = { ...objectData }
            changeObjectData.userId = data.rowData.userId
            if (data.rowData.loanId !== undefined) {
                changeObjectData.loanId = data.rowData.loanId
            }
            // id,loadid set
            setObjectData(changeObjectData)
            getDetail(changeObjectData)
            // getAmountMinMax()

        }
    }, [])

    const getStoryLine = (loanId) => {
        getStoryLines(loanId, 1, 100, callBack => {
            if (callBack) {
                setStoryLineData(callBack.data)
                if (callBack.data && callBack.data.length == 0) {
                    let initialData = []
                    // console.log(typeof (initialData))
                    initialData.push({ date: '', content: '', loanId: data.rowData.loanId, addedBy: window.sessionStorage.getItem("emailId") })
                    setStoryLineData(initialData)
                    // console.log(initialData)
                }
            }
        }, error => {

        })
    }
    const getAmountMinMax = () => {
        // console.log(location.state.rowData, 'location.state.rowData')
        const creditData = {
            "lenderId": '',
            "licenseId": ''
        }
        // getCreditAssessmentConfigApi(0, 1, creditData, callBack => {
        //     const configData = callBack[0];
        //     console.log(configData, 'configData')
        //     setAmountTenureConfig(configData)
        // })
        // loanAmounConfigApiNew('', callBack => {
        //     const configData = callBack[0];
        //     console.log(configData, 'configData')
        //     setAmountTenureConfig(configData)
        // })
    }
    const getDetail = (data) => {
        if (data.rowData.loanId !== undefined) {
            CommunityLeadGetUserLoanApi(data.rowData.loanId,
                callBack => {
                    // setLenderId(callBack.lenderId)

                    if (Object.keys(callBack).length > 0) {

                        let changeObjectData = Object.assign({}, data)
                        Object.keys(callBack).forEach(key => {
                            changeObjectData[key] = callBack[key]
                        })
                        setObjectData(changeObjectData)
                        // console.log(callBack.lenderId, 'callBack.lenderId')
                        // console.log(callBack, "proooo");
                        setWordCount(callBack.loanProposal ? callBack.loanProposal.length : 0)


                    }
                    // console.log(callBack)
                    const creditData = {
                        "lenderId": '',
                        "licenseId": ''
                    }
                    // getCreditAssessmentConfigApi(0, 1, creditData, callBack => {
                    //     const configData = callBack[0];
                    //     console.log(configData, 'configData')
                    //     setAmountTenureConfig(configData)
                    // })
                    // loanAmounConfigApiNew('', callBack => {
                    //     const configData = callBack[0];
                    //     console.log(configData, 'configData')
                    //     setAmountTenureConfig(configData)
                    // })
                }, error => {

                })
        }
    }

    const inputChange = (e, type) => {

        if (type === 'loanProposal') {
            // console.log("valll", e.target.value);
            const tempVal = e.target.value;
            setWordCount(tempVal.length)
            if (tempVal.length < wordLimit) {
                objectData.loanProposal = tempVal
                setObjectData(objectData)
            } else {
                objectData.loanProposal = tempVal.substring(0, wordLimit)
                setObjectData(objectData)
                setWordCount(wordLimit)
            }
        } else {
            let changeObjectData = Object.assign({}, objectData)
            changeObjectData[type] = e
            if (type === 'tenurePeriod') {
                changeObjectData[type] = e
            }
            if (type === 'loanAmount') {
                changeObjectData[type] = e.slice(0, 11)
            }
            setObjectData(changeObjectData)
        }
        setMessage({})
    }

    const saveHandler = (e) => {
        if (e === 'save') {
            // console.log(objectData)
            console.log(window.sessionStorage.getItem("emailId"));
            let validationMsg = CommunityLeadLoanValidation(objectData)
            if (validationMsg.status) {
                setMessage(validationMsg)
                // console.log(amountTenureConfig)
                // if ((objectData.loanAmount) >= amountTenureConfig.minAmount && (objectData.loanAmount) <= amountTenureConfig.maxAmount) {
                //     if ((objectData.tenurePeriod) >= amountTenureConfig.minTenure && (objectData.tenurePeriod) <= amountTenureConfig.maxTenure) {
                setLoaderState(true)

                CommunityLeadSaveUserLoanApi(objectData,
                    callBack => {
                        // console.log(callBack)
                        callBack.licenceId = data.rowData.licenceId
                        callBack.sourceOfIncome = callBack.sourceOfIncome
                        if(storyLineData){
                            storyLineData.map((data, i)=>{
                                storyLineData[i].addedBy = window.sessionStorage.getItem("emailId")
                            })
                        }
                        saveStoryLines(storyLineData, callBack => {

                        }, error => {

                        })
                        if (!window.location.href.includes('/external')) {
                            const obj = { 
                                rowData: callBack, 
                                communityId: data ? data.communityId : null, 
                                qrId: data ? data.qrId : null }

handleTab("addLeadDocument",obj)
                            // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_DOCUMENT : Routes.COMMUNITY_ADD_LEAD_DOCUMENT, { state: { rowData: callBack, communityId: location.state ? location.state.communityId : null, qrId: location.state ? location.state.qrId : null } })
                        } 
                        setLoaderState(false)
                    },
                    error => {
                        setLoaderState(false)
                    })
                // } else {
                //         setMessage({ field: 'tenurePeriod', msg: 'Please Enter Tenure Between ' + amountTenureConfig.minTenure + '-' + amountTenureConfig.maxTenure })

                //     }
                // } else {
                //     setMessage({ field: 'loanAmount', msg: 'Please Enter Amount Between ' + amountTenureConfig.minAmount + '-' + amountTenureConfig.maxAmount })
                // }
            } else {
                setMessage(validationMsg)
            }
        } else if (e === 'close') {
            // if (data ? data.communityId : null) {
            //     let data = data.rowData
            //     data.communityId = data ? data.communityId : null
            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // } else if (data ? data.qrId : null) {
            //     let data = data.rowData
            //     data.qrId = data ? data.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else {
            //     if (window.location.href.includes('admin')) {
            //         navigate(Routes.SUPER_ADMIN_ALL_LEADS)
            //     } else {
            //         navigate(Routes.COMMUNITY_ALL_LEADS)
            //     }
            // }
            handlePage("","list")
        } else if (e === 'back') {
            // if (!window.location.href.includes('/external')) {
            //     navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_ADDRESS : Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: objectData, communityId: location.state ? location.state.communityId : null } })
            // } else {
            //     navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: objectData } })
            // }
            const obj= { rowData: objectData, communityId: data ? data.communityId : null }
            handleTab("addLeadAddress",obj)
        }
    }

    const inputChangeForm = (e, type, i) => {
        let changeObjectData = { ...storyLineData }
        if (type === 'date') {
            // changeObjectData[i][type] = moment(e).format('DD-MM-YYYY')
            changeObjectData[i][type] =e
        }
        else {
            changeObjectData[i].content = e
        }
        // console.log(changeObjectData);
        // setStoryLineData(changeObjectData)
        // console.log(typeof)
        setMessage({})
        // setStoryLineData(changeObjectData)

        // setStoryLineData(changeObjectData)


    }

    const mainActionHandler2 = (type, index) => {
        if (type === 'mainAdd') {
            storyLineData[index + 1] = {
                date: '', content: '', loanId: data.rowData.loanId,
                addedBy: window.sessionStorage.getItem("emailId")
            }
            setStoryLineData(storyLineData)
            forceUpdate()

        } else if (type === 'mainRemove') {
            if (storyLineData && storyLineData.length > 1) {
                storyLineData.pop(index)
                setStoryLineData(storyLineData)
                forceUpdate()
            }
        }
    }

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            <PiePage
                totalPage={5}
                currentPage={4}
                heading={'Add Loan Info'}
            />
            <div className=' row' style={{marginBottom:'12px'}}>
                <div className='mb-3 col-sm-12'>
                    <InputField
                        label="Amount"
                        variant="outlined"
                        value={objectData.loanAmount}
                        name="loanAmount"
                        id="loanAmount"
                        type="number"
                        onChange={e => inputChange(e, 'loanAmount')}
                        size="small"
                        required={true}
                    />
                    <div id="loanAmountHelp" className="form-text text-danger">{message.field === 'loanAmount' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Tenure in Months"
                        variant="outlined"
                        value={objectData.tenurePeriod}
                        name="tenurePeriod"
                        id="tenurePeriod"
                        type="number"
                        onChange={e => inputChange(e, 'tenurePeriod')}
                        size="small"
                        required={true}
                    />
                    <div id="tenurePeriodHelp" className="form-text text-danger">{message.field === 'tenurePeriod' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-12' style={{marginBottom:'12px'}}>
                    <div className='row'>
                        <div className='col-sm-6 col-xs-12'>
                            <InputField
                                label="Expected Range of Interest (Minimum)"
                                variant="outlined"
                                value={objectData.expLowerRangeOfInterest}
                                name="expLowerRangeOfInterest"
                                id="expLowerRangeOfInterest"
                                type="number"
                                onChange={e => inputChange(e, 'expLowerRangeOfInterest')}
                                size="small"
                            />
                        </div>
                        <div className='col-sm-6 col-xs-12'>
                            <InputField
                                label="Expected Range of Interest (Maximum)"
                                variant="outlined"
                                value={objectData.expUpperRangeOfInterest}
                                name="expUpperRangeOfInterest"
                                id="expUpperRangeOfInterest"
                                type="number"
                                onChange={e => inputChange(e, 'expUpperRangeOfInterest')}
                                size="small"
                            />
                        </div>
                    </div>
                </div>
                {/* <div className='mb-3 col-xs-12'>
                    <SelectField
                        label={'Nature Of Loan'}
                        onChange={e => inputChange(e, 'loanType')}
                        id="loanType"
                        value={objectData.loanType}
                        name="loanType"
                        data={loanSegmentArr}
                        size={'small'}
                        required={true}
                    />
                    <div id="loanTypeHelp" className="form-text text-danger">{message.field === 'loanType' ? message.msg : ""}</div>
                </div> */}
                {/* <div className='mb-3 col-sm-12'>
                    <InputField
                        label="Reason of Loan"
                        variant="outlined"
                        value={objectData.loanReason}
                        name="loanReason"
                        id="loanReason"
                        type="text"
                        onChange={e => inputChange(e, 'loanReason')}
                        size="small"
                        required={true}
                    />
                    <div id="loanReasonHelp" className="form-text text-danger">{message.field === 'loanReason' ? message.msg : ""}</div>
                </div> */}
                <div className="col-sm-12 col-xs-12" style={{marginBottom:'12px'}}>
                    <textarea
                        placeholder="Enter Loan Description here..."
                        name="description"
                        size={'small'}
                        type='text'
                        style={{ height: '110px', width: '100%' }}
                        required={true}
                        value={objectData.loanProposal ? objectData.loanProposal : ""}
                        onChange={e => inputChange(e, 'loanProposal')}
                    />
                    <div id="loanProposalHelp" className="form-text text-danger">{message.field === 'loanProposal' ? message.msg : ""}</div>
                    {wordCount === wordLimit ? <h6 className="form-text text-danger"><b>{wordCount}/{wordLimit}</b></h6> :
                        <h6 className="form-text text-success"><b>{wordCount}/{wordLimit}</b></h6>}

                </div>
            </div>
            <div className="accordion-item " style={{marginBottom:'12px'}}>
                <h2 className="accordion-header border-bottom-heading" id="headingDocuments">
                    <button style={{ color: "white" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDocuments" aria-expanded="false" aria-controls="collapseDocuments">
                        Add Story Line
                    </button>
                </h2>
                <div id="collapseDocuments" className="accordion-collapse collapse" aria-labelledby="headingDocuments" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                        {/* {console.log(storyLineData, 'storyLineData')} */}
                        {
                            storyLineData ?
                                (storyLineData).map((data, i) => {
                                    return (<div className='card-body'>
                                        <div className='row'>
                                            <div className='col-sm-3 col-xs-12 mb-3'>
                                                {/* <DatePicker
                                                    showFutureDate={false}
                                                    label="Date"
                                                    format='DD-MM-YYYY'
                                                    value={data.date}
                                                    name="date"
                                                    size="small"
                                                    onChange={e => inputChangeForm(e, 'date', i)}
                                                    
                                                /> */}
                                                <InputField
                                                    label="Date"
                                                    value={data.date}
                                                    name="date"
                                                    size="small"
                                                    onChange={e => inputChangeForm(e, 'date', i)}
                                                     />
                                                <div id="maxCappingHelp" className="form-text text-danger">{messageConfig.field === 'maxCappingHelp' + i ? messageConfig.msg : ""}</div>

                                            </div>
                                            <div className='col-sm-7 col-xs-12' style={{marginBottom:'12px'}}>
                                                <InputField
                                                    label="Content"
                                                    variant="outlined"
                                                    value={data.content}
                                                    name={"content" + i}
                                                    id={"content" + i}
                                                    type="text"
                                                    required={true}
                                                    onChange={e => inputChangeForm(e, 'content', i)}
                                                    size="small" />
                                                {/* <div id="maxCappingHelp" className="form-text text-danger">{messageConfig.field === 'maxCappingHelp' + i ? messageConfig.msg : ""}</div> */}
                                            </div>

                                            <div className='btn-group col-sm-1 col-xs-12' style={{ marginTop: "12px" }}>
                                                <button style={{ height: "35px" }}
                                                    className='cred-btn center-block mr-3'
                                                    onClick={e => mainActionHandler2('mainAdd', i)}
                                                ><i className='fa fa-plus' /></button>
                                                <button style={{ height: "35px" }}
                                                    className='cred-btn center-block'
                                                    onClick={e => mainActionHandler2('mainRemove', i)}
                                                ><i className='fa fa-minus' /></button>
                                            </div>
                                        </div>
                                    </div>)
                                }) : ""
                        }


                    </div>
                </div>
            </div>
            <div className='mb-3 row'>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default AddUi;